import NotificationAnalytics from './NotificationAnalytics';

export default NotificationAnalytics;
